export enum Platform {
  WOO_COMMERCE = 'woo-commerce',
  SHOPIFY = 'shopify',
  STAND_ALONE = 'standalone',
  WEBFLOW = 'webflow',
  VENDARA = 'vendara',
}
